import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { VideoCategory, VideoCategoriesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class VideoCategoriesDataService {

  private uri: string = `${environment.apiUrl}video-categories`;
  private cacheKey: string = 'videoCategories.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getVideoCategory(id: number): Observable<VideoCategory|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getVideoCategories(parameters: {[param: string]: string | string[]}): Observable<VideoCategoriesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addVideoCategory(data: VideoCategory): Observable<VideoCategory|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addVideoCategories(data: VideoCategory[]): Observable<VideoCategory[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateVideoCategory(data: VideoCategory): Observable<VideoCategory|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateVideoCategories(data: VideoCategory[]): Observable<VideoCategory[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchVideoCategory(data: VideoCategory): Observable<VideoCategory|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchVideoCategories(data: VideoCategory[]): Observable<VideoCategory[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteVideoCategory(data: VideoCategory): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteVideoCategories(data: VideoCategory[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((videoCategory) => {
      ids.push(videoCategory.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
